<template>
    <div id="profile">
        <v-card-subtitle class="font-weight-bold pb-0">
            <v-icon :color="subAppColor" left>mdi-account</v-icon> Applicant Profile
        </v-card-subtitle>
        <v-card-text>
            <v-container fluid>
                <v-row no-gutters>
                    <v-col cols="12" >
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field v-model="item.firstName" readonly hide-details label="First Name"
                                    placeholder="Not available">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field v-model="item.lastName" readonly hide-details label="Last Name"
                                    placeholder="Not available">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field v-model="item.preferredName" readonly hide-details
                                    label="Preferred Name (Optional)" placeholder="Not specified">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="item.dateOfBirth" readonly hide-details label="Date of Birth"
                                    placeholder="Not available">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-select v-model="item.gender" readonly hide-details :items="genderItems"
                                    label="Gender" placeholder="Not available">
                                </v-select>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field v-model="item.prefpronoun" readonly hide-details
                                    label="Preferred Pronoun" placeholder="Not available">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" :md="item.sixftorover == 'yes' ? 6 : 12">
                                <v-checkbox
                                    v-model="item.sixftorover"
                                    label="6' or taller"
                                    value="yes"
                                    readonly
                                ></v-checkbox>
                            </v-col>
                            <v-col cols="12" md="6" v-if="item.sixftorover == 'yes'">
                                <v-select v-model="item.sixftoroverdetail" dense :items="sixftoroverdetailitems" label="Height: " outlined readonly></v-select>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="item.studentnumber" readonly hide-details label="Student Number"
                                    placeholder="Not available">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field v-model="item.registeredAt" readonly hide-details label="Registered at"
                                    placeholder="Not available">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field v-model="item.yearOfStudy" readonly hide-details
                                    label="Year of study at King's University College" placeholder="Not available">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field v-model="item.residenceTerm" readonly hide-details label="Residence Term"
                                    placeholder="Not available">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field v-model="item.internationalStudent" readonly hide-details
                                    label="International Student" placeholder="Not available">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </div>
</template>

<script>
export default {
    name: 'applicant-profile',
    props: {
        item: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            genderItems: [{
                    text: 'Female',
                    value: 'F'
                },
                {
                    text: 'Male',
                    value: 'M'
                },
                {
                    text: 'Other',
                    value: 'Other'
                },
                {
                    text: 'Non-Binary',
                    value: 'NonBinary'
                }
            ],
            sixftoroverdetailitems: [
                {text: "Please Select...", value: ""},
                {text: "6' 0”", value: "6.0"},
                {text: "6' 1”", value: "6.1"},
                {text: "6' 2”", value: "6.2"},
                {text: "6' 3”", value: "6.3"},
                {text: "6' 4”", value: "6.4"},
                {text: "6' 5”", value: "6.5"}
            ]
        }
    },
    computed: {
        subAppColor() {
            return '#FFA800';
        }
    }
}
</script>